import * as type from './mutation-type.js'

const mutations = {
  [type.CHANGE_LOGIN_STATE](state, islogined) {
    state.isLogined = islogined;
    sessionStorage.isLogined = islogined;
  },
  [type.LOGIN](state, data) {
    sessionStorage.setItem('token', data);
    sessionStorage.token = data;
    state.token = data;
  },
  [type.LOGOUT](state) {
    sessionStorage.removeItem('token');
    state.token = null;
    state.user = {};
    state.isLogined = false;
  },
  [type.USER](state, obj) {
    state.user = obj;
  },
  [type.MENU_THEME](state, obj) {
    state.menuTheme = obj;
  }
}

export default mutations
